import React, { useEffect } from "react";
import clsx from "clsx";
import moment from 'moment';
// import amplitude from 'amplitude-js';
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import { useLocation, useHistory } from "react-router-dom";
import { useLastLocation } from 'react-router-last-location';

import StarView from "./StarView";
import XbtnTitleHeader from "../../common/header/XbtnTitleHeader";

import { TYPE, URL } from "../../../constant";
import { learningResultAPI } from "../../../api/learningAPI";
import { useUserInfo, useRequest, useWorksheet } from "../../../hooks";
import {
  exactlyTitle, speedometer,
  func_animation, secondsToMinutes, learningResultCode,
} from "../../../utils/utilityEtc";
import {
  ResultTooltip, ResultIncorrect,
  ResultChartV2, StageDownTooltip, ResultButtons,
} from './';
import { mathpidLogAPICall } from "../../../redux/logData";
import useAmplitude from "../../../hooks/useAmplitude";
import ResultRecommend from "./ResultRecommend";
import { appAmplitudeEventFunc } from "../../../utils/appEventFunc";
import { A } from "../../common";
import { appsflyer, appsflyerEventName } from "../../../utils/appsflyer";

const { LRN_PRGS_STS_CD } = TYPE;

function ResultV2() {
  const history = useHistory();
  const location = useLocation();
  const logDispatch = useDispatch();
  const lastLocation = useLastLocation();
  
  const { info } = useUserInfo();
  const { t, i18n } = useTranslation();
  const { setAmplitudeLog } = useAmplitude();
  const { handleWorkSheet } = useWorksheet();
  const deviceInfo = useSelector(state => state.deviceInfo);

  const [learningResultAPICall, result] = useRequest((data) =>
    learningResultAPI(data)
  );

  useEffect(() => {
    const { state } = location;
    
    if (!info.channelCode) return;
    else if (!state?.stgCd) return;
    
    // 로그 data set 후 API Call
    logDispatch(mathpidLogAPICall({
      verbId: 'opened',
      objectId: 'learningReport',
      idName: 'stgCd',
      idValue: state.stgCd,
    }));

    const { channelCode, locale, learnerId } = info;
    const data = {
      chnCd: channelCode,
      langCd: locale,
      lrnMbrId: learnerId,
      lrnEntyScnCd: state?.lrnEntyScnCd
        ? state.lrnEntyScnCd
        : TYPE.LEARNING.TOPIC,
      stgCd: state.stgCd,
    };

    learningResultAPICall(data);
  }, []);

  useEffect(() => {
    const { state } = location;
    if (!result) return;
    console.log(`***** 결과 페이지 - ${result?.stgNm}`)
    if (state?.learningEntryType || state?.url) {
      if (lastLocation?.pathname.indexOf('/learning/answeringQuestions') > -1) {
        setAmplitudeLog({
          eventName: {
            name: '학습 종료',
            event: {
              "학습유형": state?.lrnEntyScnCd,
              "커리큘럼그룹": result?.thmaNm,
              "커리큘럼명": result?.stepNm,
              "소주제이름": result?.stgNm,
              "소주제코드": result?.stgCd,
              "제시된 문항 수": result?.totQstCt,
            }
          },
          isHackleSend: true,
        })
                    
        appsflyer({
          eventName: appsflyerEventName.learning_completed,
          eventParams: {
            af_class: state?.lrnEntyScnCd,
            af_content_type: result?.stgNm,
            af_content_id: result?.stgCd,
          }
        })

        // const identify = new amplitude.Identify()
        //   .setOnce("방문경향.최근 학습 일자", moment().format('YYYY-MM-DD HH:mm:ss'));
        // amplitude.getInstance().identify(identify);

        const setUserProperties = {
          type: 'identify',
          name: '방문경향.최근 학습 일자',
          value: moment().format('YYYY-MM-DD HH:mm:ss')
        }

        appAmplitudeEventFunc(setUserProperties, 'logAmplitude');
      }
    }

    setAmplitudeLog({
      eventName: {
        name: '학습결과 조회',
        event: {
          "소스화면": '',
          "소주제이름": result?.stgNm,
          "소주제코드": result?.stgCd,
          "커리큘럼그룹": result?.thmaNm,
          "커리큘럼명": result?.stepNm,
          "학습결과": learningResultCode(result?.lrnPrgsStsCd),
        }
      },
      isHackleSend: true,
    })

  }, [result]);

  useEffect(() => {
    if (!result) return;
    
    //학습진행 상태코드 - LPSC01: 노력, LPSC02: 기본, LPSC03: 충분, LPSC04: 훌륭
    speedometer(deviceInfo, "mySpeed", result.explSped * 0.01, '#f0f4f8', '#ff6e5f');
    const animData = { anim: '', aiLc: '' };
    switch (result.lrnPrgsStsCd) {
      case LRN_PRGS_STS_CD.LPSC01:
        animData.anim = "anim_05_07";
        animData.aiLc = "ai_lc_05_07"
        break;
      case LRN_PRGS_STS_CD.LPSC02:
        animData.anim = "anim_05_10";
        animData.aiLc = "ai_lc_05_10"
        break;
      case LRN_PRGS_STS_CD.LPSC03:
        animData.anim = "anim_05_11";
        animData.aiLc = "ai_lc_05_11"
        break;
      case LRN_PRGS_STS_CD.LPSC04:
        animData.anim = "anim_05_12";
        animData.aiLc = "ai_lc_05_12"
        break;
      default:
        break;
    }
    func_animation(animData.anim, animData.aiLc, true);
  });

  const handlePage = () => {
    console.log("***** 결과 페이지 -> 뒤로가기")
    history.goBack();
  }

  if (!result) return <div></div>;
  const time = secondsToMinutes(result.lrnTotScond);
  return (
    <React.Fragment>
      {/* 
        * 노력 : new-lr-effort
        * 기본 : new-lr-def
        * 충분 : new-lr-enough
        * 훌륭 : new-lr-nice
      */}
      <div
        className={clsx({
          "layout-def layout-lc new-lr": true,
          "new-lr-effort": result.lrnPrgsStsCd === LRN_PRGS_STS_CD.LPSC01,
          "new-lr-def": result.lrnPrgsStsCd === LRN_PRGS_STS_CD.LPSC02,
          "new-lr-enough": result.lrnPrgsStsCd === LRN_PRGS_STS_CD.LPSC03,
          "new-lr-nice": result.lrnPrgsStsCd === LRN_PRGS_STS_CD.LPSC04,
        })}
      >
        <XbtnTitleHeader
          title={result.stgNm}
          onClose={handlePage}
        />

        <div className="container">
          <div className="lr-topVisual-wrap">
            <div className="inner">
              <div className="lr-topVisual">
                <div className="lr-topVisual-head">
                  <h2 className="visual-tit">
                    {(() => {
                      switch (result.lrnPrgsStsCd) {
                        case LRN_PRGS_STS_CD.LPSC01:
                          return (
                            <>
                              <span className="ico effort"></span>{t("LC_05_07_01.msg001")}
                            </>
                          );
                        case LRN_PRGS_STS_CD.LPSC02:
                          return (
                            <>
                              <span className="ico def"></span>{t("LC_05_07_02.msg001")}
                            </>
                          );
                        case LRN_PRGS_STS_CD.LPSC03:
                          return (
                            <>
                              <span className="ico enough"></span>{t("LC_05_07_03.msg001")}
                            </>
                          );
                        case LRN_PRGS_STS_CD.LPSC04:
                          return (
                            <>
                              <span className="ico nice"></span>{t("LC_05_07_04.msg001")}
                            </>
                          );
                        default:
                          return null;
                      }
                    })()}
                  </h2>
                </div>
                <div className="lr-topVisual-body">
                  <div className="asv-wrap">
                    <div className="accuracy-wrap">
                      <div className="accuracy-header">
                        <p className="tit">{t("LC_05_07_01.msg002")}</p>
                        <ResultTooltip />
                      </div>
                      <div className="accuracy-cont">
                        <div className="accuracy">
                          <div
                            className="accuracy-bar"
                            style={{ width: `${result.explAcrcyRt}%` }}
                          />
                          <div className="accuracy-line">
                            <span className="line line1"></span>
                            <span className="line line2"></span>
                            <span className="line line3"></span>
                          </div>
                        </div>
                        <div className="accuracy-labelbox onlyTxt">
                          {/* 
                            0 ~ 66.6% 이하일때 : a-label에 클래스 on 추가
                            66.6% 초과 ~ 80% 이하일때 : a-label에 클래스 on 추가
                            80% 초과 ~ 95% 이하일때 : a-label에 클래스 on 추가
                            95% 초과일때 : a-label에 클래스 on 추가
                          */}
                          <div 
                            className={clsx({
                              "a-label label1": true,
                              "on": exactlyTitle(Number(result.explAcrcyRt)) === "label1"
                            })}
                          >
                            <span className="txt">{t("LC_05_07_01.msg022")}</span></div>
                          <div 
                            className={clsx({
                              "a-label label2": true,
                              "on": exactlyTitle(Number(result.explAcrcyRt)) === "label2"
                            })}
                          >
                            <span className="txt">{t("LC_05_07_02.msg017")}</span></div>
                          <div
                            className={clsx({
                              "a-label label3": true,
                              "on": exactlyTitle(Number(result.explAcrcyRt)) === "label3"
                            })}
                          >
                            <span className="txt">{t("LC_05_07_03.msg017")}</span></div>
                          <div 
                            className={clsx({
                              "a-label label4": true,
                              "on": exactlyTitle(Number(result.explAcrcyRt)) === "label4"
                            })}
                          >
                            <span className="txt">{t("LC_05_07_04.msg018")}</span></div>
                        </div>
                      </div>
                    </div>
                    <div className="speedometer-wrap">
                      <div className="speedometerBox">
                        <div className="gaugeBox" data-sw-m="13" data-sw-t="13" data-sw-pc="13">
                          <canvas id="mySpeed"></canvas>
                          <div className="txtBox">
                            <p className="tit">{t("LC_05_07_01.msg005")}</p>
                            <p className="txt">
                              {result.explSpedCdNm}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                { info.isPaymentCountry && !info.subScriptionPurchsYn && (
                  <A href="#none" className="pay_bnr_area" 
                    onClick={() => history.push(info?.countryCd === TYPE.COUNTRY_CODE.KOREA ? URL.PAYMENT.SUBSCRIBE : URL.PAYMENT.SUBSCRIBE_NEW )}>
                    <span className="mathpid_premium">
                      <img src={`${process.env.PUBLIC_URL}/static/images/payment/logo_mathpid.svg`} alt="mathpid premium" />
                    </span>
                    <p className="b_txt">
                      {`${i18n.language === 'ko' ? 
                        "AI 튜터로 자신만의 과정을 만드세요." : 
                        "Create your own course with AI Tutor"}`}
                    </p>
                    <p className="s_txt">
                      {`${i18n.language === 'ko' ? 
                        "자신에게 필요한 학습만을 추천받아 공부하세요!" : 
                        "Fit course program without laundering many courses!"}`}
                    </p>
                  </A>
                )}

                <div className="lr-topVisual-foot">
                  {
                    result.aiMsge && (
                      <p
                        className="txt"
                        dangerouslySetInnerHTML={{ __html: result.aiMsge }}
                      >
                      </p>  
                    )
                  }
                  {
                    TYPE.CHANNEL.GLOBAL01 === info.channelCode
                      ? (
                        <div className="lr-topVisual-ani">
                          <div className="cont">
                            <img src={`${process.env.PUBLIC_URL }/static/images/common/img_character_result_th.svg`} alt="" />
                          </div>
                        </div>
                      )
                      : (
                        <div className="lr-topVisual-ani">
                          {(() => {
                            switch (result.lrnPrgsStsCd) {
                              case LRN_PRGS_STS_CD.LPSC01:
                                return (
                                  <div className="anim-wrap" id="anim_05_07"></div>
                                )
                              case LRN_PRGS_STS_CD.LPSC02:
                                return (
                                  <div className="anim-wrap" id="anim_05_10"></div>
                                )
                              case LRN_PRGS_STS_CD.LPSC03:
                                return (
                                  <div className="anim-wrap" id="anim_05_11"></div>
                                )
                              case LRN_PRGS_STS_CD.LPSC04:
                                return (
                                  <div className="anim-wrap" id="anim_05_12"></div>
                                )
                              default:
                                break;
                            }
                          })()}
                        </div>
                      )
                  }
                </div>
              </div>
            </div>
          </div>
          
          <div className="inner">
            <div className="centermiddleBox">
              <div className="centermiddleBox-item">
                <div className="lr-mySB lr-mySB-btm">
                  <div className="lr-mySB-item item-solve">
                    <p className="lr-mySB-tit">{t("LC_05_07_01.msg008")}</p>
                    <span className="lr-mySB-txt">{result.cransrQstCt}<span className="small">/ {result.totQstCt}</span></span>
                  </div>
                  <div className="lr-mySB-item item-rate">
                    <p className="lr-mySB-tit">{t("LC_05_07_01.msg009")}</p>
                    <span className="lr-mySB-txt">{result.cransrAvg}%</span>
                  </div>
                  <div className="lr-mySB-item item-time">
                    <p className="lr-mySB-tit">{t("LC_05_07_01.msg010")}</p>
                    <span className="lr-mySB-txt">
                      {
                        t("LC_05_07_01.msg011", { m: time.min, s: time.sec})
                      }
                    </span>
                  </div>
                </div>
                <div className="lr-mySB lr-mySB-btm">
                  {
                    (result?.drilldwQstCt && result.drilldwQstCt > 0) ? (
                      <StageDownTooltip
                        count={result.drilldwQstCt}
                      />
                    ) : null
                  }
                  {
                    (result?.wransrQstCt && result.wransrQstCt > 0) ? (
                      <ResultIncorrect result={result} />
                    ) : null
                  }
                </div>
                {/* <ResultRecommend /> */}
                {
                  (result?.aiRecommList && result.aiRecommList.length > 0) && (
                    <ResultRecommend 
                      aiRecommList={result.aiRecommList}
                      lrnPrgsStsCd={result.lrnPrgsStsCd}
                    />
                  )
                }
                
                {
                  (result.lrnCmnResList.length > 1) && (
                    <div className="chartBox">
                      <div className="lr-chart-tit">{t("LC_05_07_01.msg017")}</div>
                      <div className="lr-chart">
                        <ResultChartV2
                          lrnCmnResList={result.lrnCmnResList}
                        />
                      </div>
                      <div className="lr-chart-label">
                        <span className="rate">{t("LC_05_07_01.msg009")}</span>
                        <span className="accuracyl">{t("LC_05_07_01.msg002")}</span>
                        <span className="speed">{t("LC_05_07_01.msg005")}</span>
                      </div>
                    </div>
                  )
                }
                {
                  (TYPE.CHANNEL.GLOBAL01 === info.channelCode && result.workSheetYn === 'Y') && (
                    <div className="lr-mySB lr-mySB-btm">
                      <div className="lr-mySB-item item-solve ht">
                        <span className="wsDwon_wrap">
                          <A onClick={() => handleWorkSheet(result)}> <button type="button">{t("LC_05_07_01.msg023")}</button></A>
                        </span>
                      </div>
                    </div>
                  )
                }
              </div>
            </div>
          </div>
        </div>
        <ResultButtons
          result={result}
          // learningEntryType={location.state?.learningEntryType}
        />
      </div>
      {
        (info.channelCode === TYPE.CHANNEL.GM_APP && result) && <StarView stgNm={result.stgNm}/>
      }
      
    </React.Fragment>
  );
}

export default ResultV2;
